import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { Gs1ComponentsLibraryModule } from "@gs1france/gs1-components-library";
import { NgxMatIntlTelInputComponent } from "ngx-mat-intl-tel-input";
import { CodeOnlineCard } from "./components/code-online/code-online.component";
import { FooterComponent } from "./components/footer/footer.component";
import { FormulaireContactComponent } from "./components/formulaire-contact/formulaireContact.component";
import { FormulairePerso } from "./components/formulaire-perso/formulaire-perso.component";
import { HeaderComponent } from "./components/header/header.component";
import { HeaderSimplifiedComponent } from "./components/header/headersimplified.component";
import { AutoLoginComponent } from "./components/login/autologin.component";
import { LoginComponent } from "./components/login/login.component";
import { MentionsLegalesComponent } from "./components/mentions-legales/mentions-legales.component";
import { SearchCompany } from "./components/search-company/search-company.component";
import { UnauthorizedAccount } from "./components/unauthorized/unauthorizedAccount.component";
import { UnauthorizedContact } from "./components/unauthorized/unauthorizedContact.component";
import { UnsubscribeComponent } from "./components/unsubscribe/unsubscribe.component";
import { UploadComponent } from "./components/upload/upload.component";
import { DndDirective } from "./directives/dnd.directive";
import { AuthGuardService } from "./guards/auth-guard.service";
import { MatStepperModule } from "@angular/material/stepper";
import { MatRadioModule } from "@angular/material/radio";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { PipesModule } from "./Pipe/question/filterquestions.module";
import { ConnectComponent } from "./components/connect/connect.component";

@NgModule({
    declarations: [
        FooterComponent, HeaderComponent, HeaderSimplifiedComponent,
        FormulaireContactComponent,
        UploadComponent, CodeOnlineCard, FormulairePerso,
        ConnectComponent, LoginComponent, AutoLoginComponent, MentionsLegalesComponent,
        SearchCompany, UnauthorizedAccount, UnauthorizedContact, UnsubscribeComponent,
        DndDirective
    ],
    imports: [
        Gs1ComponentsLibraryModule, MatIconModule, RouterModule, FormsModule, CommonModule,
        NgSelectModule, NgxMatIntlTelInputComponent, ReactiveFormsModule, MatDialogModule,
        MatTooltipModule, MatAutocompleteModule, NgSelectModule, MatFormFieldModule,
        TranslateModule, MatCheckboxModule, MatStepperModule, MatRadioModule, MatInputModule, MatButtonModule,
        PipesModule
        
    ],
    providers: [
        DndDirective,AuthGuardService
    ],
    exports: [
        Gs1ComponentsLibraryModule, ReactiveFormsModule, FormsModule, CommonModule, UploadComponent, MatDialogModule,
        FooterComponent, HeaderComponent, CodeOnlineCard, NgSelectModule, MatTooltipModule, SearchCompany, TranslateModule,PipesModule
    ]
})
export class CoreModule {}
